export default __webpack_public_path__ + "static/media/Rectangle1.4e135409.png";